import React from "react";
import styles from "../../Introspekcije.module.css";
import CommentSection from "./components/CommentSection";

function MentorComment({
  isMentorRole,
  userId,
  showEditComment,
  comments,
  userData,
  mentorData,
  dbComment,
  handleInputChange,
  setShowEditComment,
  introspectionData,
  inputValue,
  minCommentSize,
  commentSize,
  setIsNoCharComment,
}) {
  return (
    <div className={styles.mentorCommentWrapper}>
      <span className={styles.commentLabel}>
        {isMentorRole &&
        (userId === "Voditelj" ||
          userId === "Polaznik VT-a" ||
          userId === "Terapeut" ||
          userId === "Učitelj" ||
          userId === "Supervizor")
          ? showEditComment
            ? "Uredi komentar"
            : comments
              ? "Moj komentar"
              : ""
          : "Komentar mentora"}
      </span>
      {((comments || dbComment) &&
        !isMentorRole &&
        introspectionData.userInIntrospection.isRead) ||
      isMentorRole ? (
        <CommentSection
          isMentorRole={isMentorRole}
          userData={userData}
          mentorData={mentorData}
          dbComment={dbComment}
          showEditComment={showEditComment}
          handleInputChange={handleInputChange}
          userId={userId}
          setShowEditComment={setShowEditComment}
          introspectionData={introspectionData}
          comments={comments}
          inputValue={inputValue}
          minCommentSize={minCommentSize}
          commentSize={commentSize}
          setIsNoCharComment={setIsNoCharComment}
        />
      ) : (
        <div className={styles.noCommentContainer}>
          Mentor još nije ostavio komentar
        </div>
      )}
    </div>
  );
}

export default MentorComment;
